import { defineComponent as _defineComponent } from 'vue';
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "login-page flex"
};
const _hoisted_2 = {
  class: "login-panel flex-full"
};
const _hoisted_3 = {
  class: "panel-container"
};
import { reactive, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import accoutAction from './components/accout-action.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'login',
  setup(__props) {
    const bgDescSzie = reactive({
      width: 0,
      height: 0
    });
    const route = useRoute();
    const router = useRouter();
    onMounted(() => {
      document.title = '登录';
      const width = document.documentElement.clientWidth || document.body.clientWidth;
      bgDescSzie.height = document.documentElement.clientHeight || document.body.clientHeight;
      bgDescSzie.width = bgDescSzie.height * 0.75;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "bg-desc",
        style: _normalizeStyle({
          width: `${bgDescSzie.width}px`,
          height: `${bgDescSzie.height}px`
        })
      }, null, 4), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "login-text"
      }, "欢迎登录", -1)), _createVNode(accoutAction)])])]);
    };
  }
});